import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolAction } from '../symbol.action';

type IDependencies = IClientApiDependencySegment;

export const bulkRemoveSymbolsEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolAction.bulkRemove.started),
  mergeMap((params) => {
    return dependencies.api.bulkDeleteCoreSymbols({ symbolIds: params.symbolIds }).pipe(
      mergeMap(() => of(SymbolAction.bulkRemove.done({ params }))),
      catchApiError((error) => of(
        SymbolAction.bulkRemove.failed({ params, error }),
        createApiErrorNotification(error),
      )),
    );
  }),
);
